rs.module("development/codedemosbusiness-messages",

    ["controls/components/event-banner"],

    function (eventBanner) {

        var _jsSelectors;

        //
        // Initialize the module
        //
        function initialize(jsSelectors) {

            _jsSelectors = jsSelectors;

            // Hook up click event to add errors via ajax
            $.js(_jsSelectors.addErrorButton).on('click', function () {

                // Add error to event banner
                eventBanner.addErrorMessages("This is an async error message.", "Second Error Message", "Third Error.");
            });

            // Hook up click event to add info via ajax
            $.js(_jsSelectors.addInfoButton).on('click', function () {

                // Add info to event banner
                eventBanner.addInformationalMessages("This is an async info message.", "This is a second info message.");
            });

            // Hook up click event to clear errors
            $.js(_jsSelectors.clearErrorButton).on('click', function () {

                // Remove error messages
                eventBanner.removeErrorMessages();
            });

            // Hoop up click event to clear info
            $.js(_jsSelectors.clearInfoButton).on('click', function () {

                // Remove informational messages
                eventBanner.removeInformationalMessages();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);